import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LinkHubPage from "@/pages/LinkHubPage";
import LegalPage from "@/pages/LegalPage";
import TutorialPage from "@/pages/TutorialPage";
import CookieConsent from "@/components/CookieConsent";
import ScrollToTop from "@/components/ScrollToTop";
import OpenAIAdsPixel from "@/components/OpenAIAdsPixel";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<LinkHubPage />} />
          <Route path="/tutorial" element={<TutorialPage />} />
          <Route path="/privacy-policy" element={<LegalPage slug="privacy-policy" />} />
          <Route path="/terms-and-conditions" element={<LegalPage slug="terms-and-conditions" />} />
          <Route path="/gdpr-cookies" element={<LegalPage slug="gdpr-cookies" />} />
          <Route path="/risk-disclaimer" element={<LegalPage slug="risk-disclaimer" />} />
          <Route path="*" element={<LinkHubPage />} />
        </Routes>
        <CookieConsent />
        <OpenAIAdsPixel />
      </BrowserRouter>
    </div>
  );
}

export default App;
